import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { GridStateService } from './grid-state.service';
let GridStateClearGuard = class GridStateClearGuard {
    constructor(_gridStateService) {
        this._gridStateService = _gridStateService;
    }
    canDeactivate() {
        this._gridStateService.clearGridIds();
        return true;
    }
};
GridStateClearGuard.ctorParameters = () => [
    { type: GridStateService }
];
GridStateClearGuard = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [GridStateService])
], GridStateClearGuard);
export { GridStateClearGuard };
